<template>
  <header id="cover" class="pt-5 pb-5">
    <b-container>
      <b-row>
        <b-col align="center">
          <b-img
            :src="require('../../assets/avataaars-circle.svg')"
            alt="geek"
            width="264px"
            height="280px"
          ></b-img>
          <h1 class="masthead-heading text-uppercase mt-5">The Geeky Helper</h1>
          <divider />
          <h2>Tech help for the community</h2>
          <!-- <sticker class="pb-5">
            <h1>
              <span>I'm</span><br />
              <span class="font-large">here</span><br />
              <span class="font-medium">for</span><br />
              <span class="font-large">lockdown!</span>
            </h1></sticker
          > -->
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
// import Sticker from "./Sticker.vue";

export default {
  name: "Cover",
  components: {
    // Sticker,
  },
};
</script>

<style scoped>
#cover {
  background-color: #1f88dd;
}

.masthead-heading {
  font-weight: 700;
  font-size: 2.75rem;
}
</style>
